  // $(window).on('load', function() {
$( document ).ready(function() {
  setTimeout(function(){
  $('.formbuilder').css("opacity",'1');
  }, 1);
  });
$(".desc_first").addClass("active")
  $('.accord1 p').click(function(){
    
      if($(this).next(".accord-content").slideToggle()){
         $(this).find('.svg_down_product').toggleClass("add");
         $(".desc_first").removeClass("active")
        $(this).addClass("active");
        $(this).closest("div").siblings().find('.accord-content').slideUp();
        $('.accord1 p').not(this).find('.svg_down_product').removeClass("add");
         $(this).removeClass("active");
      } 
      
   
 });
$(document).ready(function(){
 $('.was-price.theme-money').before('<span class="mrp">M.R.P.:</span>');

  var custom_percentage = $('.custom_percentage').text();
  $('.current-price.theme-money').before('<span ><b class="save_percentage">'+custom_percentage+'</b><b class="offer_price_dsc">Offer Price:</b></span>');
  $('.current-price.theme-money').after('<br>');
   // men-button and women-button start  
  var change = localStorage.getItem("change");
  if(change == 'men'){
    men_change();
    $('.women-button').removeClass('women-click');
    $('.men-button').removeClass('men-click');
    $('.container-head').css('border-color','#87B539');
    $('a.cart-summary__close.toggle-cart-summary').removeClass('custom_background');
    $('.custom_color_green').removeClass('custom_background');
    $('body').addClass('template-dorco-men').removeClass('template-dorco-women');
  }else if(change == 'women'){
    women_change();
    $('.men-button').addClass('men-click');
    $('.women-button').addClass('women-click');
    $('.container-head').css('border-color','#D15A80');
    $('a.cart-summary__close.toggle-cart-summary').addClass('custom_background');
    $('.custom_color_green').addClass('custom_background');
    $('body').addClass('template-dorco-women').removeClass('template-dorco-men');
  }else{
    men_change();
    $('.women-button').removeClass('women-click');
    $('.men-button').removeClass('men-click');
    $('.container-head').css('border-color','#87B539');
    $('a.cart-summary__close.toggle-cart-summary').removeClass('custom_background');
    $('.custom_color_green').removeClass('custom_background');
    $('body').addClass('template-dorco-men').removeClass('template-dorco-women');
  }

  slickBanner();
  
  function men_change(){
    $('#content .shopify-section').each(function(){
      // $(this).addClass('change-template');
      $('body').find("[change-template='women']").hide();
      $('body').find("[change-template='men']").show();
    });
  }
  function women_change(){
    $('#content .shopify-section').each(function(){
      // $(this).addClass('change-template');
      $('body').find("[change-template='men']").hide();
      $('body').find("[change-template='women']").show();
    });
  }
 
  function slickBanner(){
      $('.slideshow-cstm').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 1000,
        infinite: true,
        autoplay: true,
        prevArrow:'<button type="button" class="slick-prev slick-arrow" aria-label="Previous" style=""><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow" aria-label="Next" style=""><svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg></button>'
    });
  };

  
    $('body').on('click','.men-button', function(){
      men_change();
      localStorage.setItem("change", "men");
      $('.women-button').removeClass('women-click');
      $(this).removeClass('men-click');
      $('.container-head').css('border-color','#87B539');
      $('a.cart-summary__close.toggle-cart-summary').removeClass('custom_background');
      $('.custom_color_green').removeClass('custom_background');
      $('body').addClass('template-dorco-men').removeClass('template-dorco-women');
       $('.Widest_range').hide();
       $('.section-image-with-text').show();
       $('.shaving_technology_women').hide();
      $('.slideshow-cstm').slick('unslick'); 
      slickBanner();
    });
    $('body').on('click','.women-button', function(){
      women_change();
      localStorage.setItem("change", "women");
      $('.men-button').addClass('men-click');
      $(this).addClass('women-click');
      $('.container-head').css('border-color','#D15A80');
      $('a.cart-summary__close.toggle-cart-summary').addClass('custom_background');
      $('.custom_color_green').addClass('custom_background');
      $('body').addClass('template-dorco-women').removeClass('template-dorco-men');
      $('.section-image-with-text').hide();
      $('.Widest_range').show();
     $('.shaving_technology_women').show();
      $('.slideshow-cstm').slick('unslick'); 
      slickBanner();
    });
  // men-button and women-button end  

  // section/accordion
  $('.custom-accordion-heading').click(function(){
    var accordion = $(this).parent().hasClass('accordion-open');
    if(accordion){
      $(this).parent().find('.custom-accordion-paragraph').slideUp('slow');
      $(this).parent().removeClass('accordion-open');
    }else{
      $('.custom-accordion-paragraph').not(this).slideUp();
      $(this).parent().find('.custom-accordion-paragraph').slideDown('slow');
      $('.custom-accordion-content').removeClass('accordion-open');
      $(this).parent().addClass('accordion-open');
    }
  });
  // end section/accordion
});

// =======Accordion=========
// footer slideup =====
  $(document).ready(function () {
    $(window).on("resize", function (e) {
        checkScreenSize();
    });
    checkScreenSize();   
    function checkScreenSize(){
        var newWindowWidth = $(window).width();
        if (newWindowWidth <= 769) {
           $(".plain li:first-child").click(function (){
         // $(this).siblings().toggle('slow');
     });
        }   
    }
});
$(document).ready(function () {
   $(".plain li:first-child").click(function () {
      $(this).siblings().toggle('slow');
   });
   $(".product-add.mini-form").click(function () {
      $('body').parents().find('#colorbox .payment-and-quantity__add').addClass("hello");
   });
});

// section/tab-feature-collection start
 $('.tab-feature-collection .tab_index_1').addClass('cstm_active');
 $('.tab-feature-collection .tab_headings button').click(function () {
   $('.tab-feature-collection .tab_headings button').removeClass('cstm_active');
   $(this).addClass('cstm_active');
   var match = $(this).attr('match');
   $('.tab-feature-collection .tab_content_cstm').each(function(){
     var match_cstm = $(this).attr('match');
     if(match == match_cstm){
       $('.tab-feature-collection .tab_content_cstm').hide();
       $(this).show();
     }
   });
 });
// section/tab-feature-collection end --
// section/men-women-feature-collection start---------
  $('.men-women-feature-collection .tab_index_1').addClass('cstm_active');
  $('.men-women-feature-collection .tab_headings button').click(function () {
   $('.men-women-feature-collection .tab_headings button').removeClass('cstm_active');
   $(this).addClass('cstm_active');
   var match = $(this).attr('match');
   $('.men-women-feature-collection .tab_content_cstm').each(function(){
     var match_cstm = $(this).attr('match');
     if(match == match_cstm){
       $('.men-women-feature-collection .tab_content_cstm').hide();
       $(this).show();
     }
   });
 });
// men-women-feature-collection end --
// $('.tab_index_2 ').click(function () {
//    // $('.tab_index_1').removeClass('cstm_active');
//    $('.opposing-items.opposing-items--heading.tab_coll button.tab_index_2').addClass('cstm_active');
// });
// $('.tab_index_1 ').click(function () {
//    $('.opposing-items.opposing-items--heading.tab_coll button.tab_index_2').removeClass('cstm_active');
// });


// Product page click the read more button

$('.readmore').click(function(e) {  
$('html, body').animate({scrollTop: $('.custom-accordion').offset().top - 120}, 1000);
$('html, body').find('.container.tabs li:first').addClass("active").siblings().removeClass("active");
$('.custom-accordion-content:first').show().siblings().hide();
});
$('.spr-stars').click(function(e) {  
$('html, body').animate({scrollTop: $('.custom-accordion').offset().top - 120}, 1000);
$('html, body').find('.container.tabs li.fourth').addClass("active").siblings().removeClass("active");
$('.custom-accordion-content.fourth').show().siblings().hide();
});

// Product page description tab

$('#tabs-nav li:first-child').addClass('active');
$('.custom-accordion-content').hide();
$('.custom-accordion-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.custom-accordion-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});
$(document).ready(function () {
  $('.toolbar-search').click(function(){
   setTimeout(function(){
    if($('.main-search.search-cus').hasClass('hello')){
      // $('.container-head').css('z-index','978');
      $('body').removeClass('open__search');
       $('.search-cus').removeClass("hello").hide();
     $('.hidden-search-container__veil').hide();
    }
    else{
      $('body').addClass('open__search');
       $('.search-cus').addClass("hello").show();
     $('.hidden-search-container__veil').show();
    }  
     }, 500);
  });
  
  $('.closee').click(function(){
   $('.toolbar-search').click();
     
  });
});

jQuery(document).ready(function($) {
      $('.about_dorco-slider').slick({
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        nextArrow: '<button class="slick-next slick-arrow"><svg class="right_collection_svg" xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M0 3L7.5 10.5L0 18L1.5 21L12 10.5L1.5 0L0 3Z" fill="black"></path></svg></button>',
        prevArrow: '<button class="slick-prev slick-arrow"><svg class="right_collection_svg" xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none"><path d="M0 3L7.5 10.5L0 18L1.5 21L12 10.5L1.5 0L0 3Z" fill="black"></path></svg></button>',
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
           breakpoint: 400,
           settings: {
              slidesToShow: 2,
              slidesToScroll: 1
           }
        }]
    });
});